import { defineMessage } from "react-intl";

// TODO: This will be refactored to separate out validation logic from UI technology. Validators shouldn't need to know anything
// about the UI framework being used so if we ever swap out that tech, business logic and it's unit tests can remain consistent 
// while the UI technology is updated.
export const usernameValidator = {
    validateFormat: (username) => {
      const trimmedUsername = username?.trim();
      const errors = [];
      // Skip validation if username is empty.
      if (!trimmedUsername) {
        return errors;
      }
      const usernameValid = trimmedUsername.match(/[\p{L}\p{M}\p{S}\p{N}\p{P}]+/u)?.[0].length === trimmedUsername.length;
      if (!usernameValid) {
        errors.push({
          message: defineMessage({
            id: "invalidUsername",
            defaultMessage: "This username appears invalid, please try again",
            description: "Error message for username field"
          }),
          context: {}
        });
        if (trimmedUsername.match(/\s/)) {
          errors.push({
            message: defineMessage({
              id: "usernameContainsSpaces",
              defaultMessage: "The username contains spaces",
              description: "Error message for username field"
            }),
            context: {}
          });
        }
      }
      return errors;
    },
    validateRules: () => []
  };